<i18n>
de:
  Public transport directions: Wegbeschreibung für öffentliche Verkehrsmittel
  Driving directions: Wegbeschreibung
  Bicycle directions: Wegbeschreibung
  Walking directions: Wegbeschreibung
  Time: Dauer
  Start: Abfahrtszeit
  Distance: Entfernung
  Routes: Routen
  Instructions: Beschreibungen
  km: km
  Section: Abschnitt
  TakeVehicleTo: Nehmen Sie den <span class="transit-name">{mode} {name}</span> nach <span class="transit-headsign">{transportHeadsign}</span>.
  regionalTrain: Regionalzug
  bus: Bus
  WalkTo: Gehen Sie {metres} Meter nach {destination}.
en:
  TakeVehicleTo: Take <span class="transit-name">{mode} {name}</span> travelling to <span class="transit-headsign">{transportHeadsign}</span>.
  bus: bus
  regionalTrain: regional train
  WalkTo: Walk {metres} metres to {destination}.
</i18n>
<template>
<div id="route" v-if="route">
  <!-- v8 response -->
  <div v-for="(section, sectionNo) of (sections)" :key="sectionNo">
    <h2 v-if="sectionNo === 0">{{ $t(transportModeTitle + ' directions') }}</h2>
    <template v-if="transportModeTitle === 'Driving'">
      <h3 v-if="route.sections.length > 1">
        {{ `${$t('Section')} ${sectionNo + 1}` }} ({{ Math.round((section.summary || section.travelSummary).length/100)/10}} {{ $t('km') }})
      </h3>
      <table class="route-summary">
        <tr>
          <th>{{ $t('Time') }}:</th>
          <td>{{ routeDuration(sectionNo) }}</td>
        </tr>
        <tr v-if="sectionStartTime(sectionNo)">
          <th>{{ $t('Start') }}:</th>
          <td>{{ routeStartDate && routeStartDate + ' at '}} {{ sectionStartTime(sectionNo) }}</td>
        </tr>
        <tr>
          <th>{{ $t('Distance') }}:</th>
          <td>{{ routeDistance(sectionNo) }}</td>
        </tr>
      </table>
    </template>
    <template v-if="transportModeTitle === 'Public transport'">
      <!-- <h3 v-if="section.type === 'pedestrian'">
        Walk to {{ section.arrivalName }} -->
        <!-- {{ `${$t('Section')} ${sectionNo + 1}` }} ({{ Math.round((section.summary || section.travelSummary).length/100)/10}} {{ $t('km') }}) -->
      <!-- </h3> -->
      <!-- <h3 v-if="section.type === 'transit'">
        {{ $t('TakeVehicleTo', { mode: $t(section.transport.mode), name: section.transport.name, transportHeadsign: section.transportHeadsign }) }}
      </h3>
      <table class="route-summary">
        <tr>
          <th>{{ $t('Time') }}:</th>
          <td>{{ routeDuration(sectionNo) }}</td>
        </tr>
        <tr v-if="sectionStartTime(sectionNo)">
          <th>{{ $t('Start') }}:</th>
          <td>{{ routeStartDate && routeStartDate + ' at '}} {{ sectionStartTime(sectionNo) }}</td>
        </tr>
        <tr>
          <th>{{ $t('Distance') }}:</th>
          <td>{{ routeDistance(sectionNo) }}</td>
        </tr>
      </table> -->
      <div class="actions" v-if="!section.actions">
        <table>
          <tr>
            <!-- <td class="time" v-if="action.cumulative"> {{ action.cumulative }} </td> -->
            <!-- <td class="time"></td> -->
            <td class="time">{{ routeStartDate && routeStartDate + ' at '}} {{ sectionStartTime(sectionNo, true) }}</td>
            <!-- <td> {{ $t('TakeVehicleTo', { mode: $t(section.transport.mode), name: section.transport.name, transportHeadsign: section.transportHeadsign }) }}</td> -->
            <td v-if="section.type === 'transit'" v-html="$t('TakeVehicleTo', { mode: $t(section.transport.mode), name: section.transport.name, transportHeadsign: section.transportHeadsign })"></td>
            <td v-if="section.type === 'pedestrian'" v-html="$t('WalkTo', { destination: section.arrival.place.name, minutes: Math.round(section.travelSummary.duration / 120), metres: section.travelSummary.length.toLocaleString()} )"></td>
            <td class="changeId">
              <span>{{ sectionNo }}</span>
            </td>
          </tr>
        </table>
      </div>
    </template>
    <div class="actions">
      <table>
        <tr v-for="(action, actionNo) of section.actions" :key="actionNo">
          <!-- <td class="time" v-if="action.cumulative"> {{ action.cumulative }} </td> -->
          <td class="time"> {{ actionStartTime(sectionNo, actionNo) }} </td>
          <td> {{ action.instruction }}</td>
          <td class="changeId" v-if="sectionNo !== 0 && actionNo === 0" >
            <span>{{ sectionNo }}</span>
          </td>

        </tr>
      </table>
    </div>
  </div>
  <!-- v7 response -->
  <div v-if="routeLegs">
    <h2>{{ $t(transportModeTitle + ' directions') }}</h2>
    <table class="route-summary">
      <tr>
        <th>{{ $t('Time') }}:</th>
        <td>{{ routeDuration() }}</td>
      </tr>
      <tr v-if="routeStartTime">
        <th>{{ $t('Start') }}:</th>
        <td>{{ routeStartDate && routeStartDate + ' at '}} {{ routeStartTime }}</td>
      </tr>
      <tr>
        <th>{{ $t('Distance') }}:</th>
        <td>{{ routeDistance() }}</td>
      </tr>
      <tr v-if="route.publicTransportLine">
        <th>{{ $t('Routes') }}:</th>
        <td>{{ route.publicTransportLine.map(l => l.lineName).join(',  ') }}</td>
      </tr>
    </table>

    <h3>{{ $t('Instructions') }}</h3>
    <div v-for="leg of routeLegs">
      <table class="maneuvers">
        <tr v-for="maneuver of leg.maneuver">
          <td class="time" v-if="isScheduled && maneuver.time"> {{ maneuver.time.slice(11, 19) }} </td>
          <td class="time" v-if="!isScheduled && maneuver.cumulative"> {{ maneuver.cumulative }} </td>
          <td v-html="maneuver.instruction">{{maneuver.instruction}}</td>
          <td class="changeId" v-if="hasChangeIds"> <span v-if="maneuver.changeId !== undefined">{{ maneuver.changeId }}</span> </td>
        </tr>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import humanizeDuration from 'humanize-duration';
function pad2 (x) {
  return ('0' + x).slice(-2);
}
export default {
  props: ['route', 'dateSpecified', 'transportModeTitle'],
  data: () => ({
  }),
  name: 'RoutingInstructions',
  mounted() { window.RoutingInstructions = this; },
  computed: {
    routeStartDate () {
      if (!this.dateSpecified) {
        return '';
      }

      if (this.route && this.route.sections && this.route.sections[0] && this.route.sections[0].departure && this.route.sections[0].departure.time) {
        // public transit routes from v8 don't include an overall departure date and date-flag every section even if it's today.
        const startDate = new Date(this.route.sections[0].departure.time).toISOString().slice(0, 10);
        const now = new Date().toISOString().slice(0, 10);
        if (startDate !== now) {
          return startDate;
        } else {
          return ''
        }
      }
      if (!this.route || !this.route.summary.departure) {
        return '';
      }
      const date = new Date(this.route.summary.departure.slice(0, 10));
      return `${pad2(date.getDate() + 1)}.${pad2(date.getMonth() + 1)}.${date.getFullYear()}`;
    },
    routeStartTime () {
      return this.route && this.route.summary.departure && this.route.summary.departure.slice(11, 19);
    },
    routeLegs () {
      return this.route && this.route.leg;
    },
    hasChangeIds () {
      return this.route && this.routeLegs.find(l => l.maneuver.find(m => m.changeId));
    },
    isScheduled () {
      return this.route.mode && this.route.mode.transportModes[0] === 'publicTransportTimeTable';
    },
    sections() {
      if (!this.route.sections) {
        return [];
      }
      const sections = this.route.sections;
      for (const section of sections) {
        if (section.arrival && section.arrival.place && section.arrival.place.name) {
          section.arrivalName = section.arrival.place.name.replace(/ \|.*/, '').replace(/\\:/, ':');
        }
        if (section.transport && section.transport.headsign) {
          section.transportHeadsign = section.transport.headsign.replace(/ \|.*/, '').replace(/\\:/, ':');
        }
      }
      console.log(sections);
      return sections;
    }
  },
  methods: {
    routeDuration (sectionNo) {
      return this.route && humanizeDuration(this.routeSummary(sectionNo).baseTime * 1000, { round: true, units: ['h', 'm'], language: this.$i18n.locale });
    },
    routeDistance (sectionNo) {
      return this.route && `${Math.round(this.routeSummary(sectionNo).distance * 10 / 1000) / 10} ${this.$t('km')}`;
    },
    routeSummary (sectionNo) {
      if (this.route && this.route.summary) {
        return this.route.summary;
      } else {
        const section = this.route.sections[sectionNo];
        return {
          baseTime: (section.summary || section.travelSummary).duration,
          distance: (section.summary || section.travelSummary).length
        }
      }
    },
    sectionStartTime (sectionNo, short = false) {
      const end = short ? 16 : 19;
      return this.sections[sectionNo] && this.sections[sectionNo].departure && this.sections[sectionNo].departure.time.slice(11, end);
    },
    actionStartTime(sectionNo, actionNo) {
      // pedestrian steps in transit directions don't have directly encoded timestamps
      // new Date(new Date('2020-10-12T07:24:00Z').getTime() + 1035000).toISOString()
      const section = this.sections[sectionNo];
      // times are in local time. It's easiest just to pretend they're in UTC since Date can't give us non-UTC strings.
      let cumulative = new Date(section.departure.time.replace('+02:00', 'Z')).getTime();
      for (let precedingActionNo = 0; precedingActionNo < actionNo; precedingActionNo++) {
        cumulative += section.actions[precedingActionNo].duration
      }
      return new Date(cumulative).toISOString()
        .match(/\d\d:\d\d/)[0]
        // .replace(\
        // .replace(/\.\d\d\dZ$/, '')
    }

  }
}
</script>

<style scoped>
.time {
  color: #555;
  vertical-align: top;
  font-style:italic;
  width:3em;
}

.route-summary {
  margin-bottom:1em;
}

.route-summary th {
  text-align: right;
}
.route-summary th {
  /* padding: 0.5em 0; */
}
.route-summary td {
  padding:0 0.25em;
}

.changeId {
  vertical-align: top;
  padding: 0;
  margin: 0;
}

.changeId span {
  border: 1px solid black;
  padding: 0px 6px;
  border-radius:40px;
}

.maneuvers td, .actions td {
  padding: 0.5em 0.5em;
}

.maneuvers .station,
.maneuvers .transit,
.maneuvers .line {
  font-weight:bold;
}

</style>
<style>
.transit-name {
  font-weight: bold;
}

.transit-headsign {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/routing/RoutingInstructions.vue